import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";
import { translateError } from "@/i18n/errors";

const lines = (s) => s.split(/\n|,/).map((x) => x.trim()).filter(Boolean);

// « Pour quels commerces » tags + « Fonctionnalités » bullets (written in French, translated automatically).
export const MinisiteEditor = ({ app, onSaved }) => {
  const { t } = useI18n();
  const [tags, setTags] = useState((app.minisite?.business_tags || []).join("\n"));
  const [feats, setFeats] = useState((app.minisite?.features || []).join("\n"));
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put(`/admin/apps/${app.id}/minisite`, { business_tags: lines(tags), features: feats.split("\n").map((x) => x.trim()).filter(Boolean) });
      toast.success(t("mini.saved"));
      onSaved?.(data);
    } catch (err) {
      toast.error(translateError(err, t));
    } finally {
      setBusy(false);
    }
  };
  return (
    <section className="card-carbon min-w-0 space-y-4 rounded-2xl p-5" data-testid="minisite-editor">
      <h3 className="font-display text-sm font-bold uppercase tracking-wider text-white">{t("mini.editorTitle")}</h3>
      <div className="grid gap-4 md:grid-cols-2">
        <div className="min-w-0 space-y-1.5">
          <Label htmlFor="mini-tags">{t("mini.forWho")}</Label>
          <Textarea id="mini-tags" rows={5} value={tags} onChange={(e) => setTags(e.target.value)} placeholder={t("mini.tagsPlaceholder")} data-testid="minisite-tags-input" />
        </div>
        <div className="min-w-0 space-y-1.5">
          <Label htmlFor="mini-feats">{t("mini.features")}</Label>
          <Textarea id="mini-feats" rows={5} value={feats} onChange={(e) => setFeats(e.target.value)} placeholder={t("mini.featuresPlaceholder")} data-testid="minisite-features-input" />
        </div>
      </div>
      <p className="break-words text-xs text-neutral-500">{t("mini.editorHint")}</p>
      <button type="button" className="btn-gold btn-sm" disabled={busy} onClick={save} data-testid="minisite-save-btn">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} {t("mini.save")}
      </button>
    </section>
  );
};
